/** 卡类型 */
export const CARD_TYPE = {
  /** 信用卡 => 01 */
  CREDIT: '01',
  /** 储蓄卡 => 02 */
  DEBIT: '02',
  /** 账户 => 03 */
  ACCOUNT: '03',
}

/** 银行code */
export const BANK_NO = {
  /** 大丰 2021年4月停用 */
  // TAI_FUNG: '02',
  /** 澳门国际 2020年11月停用 */
  // LUSO: '03',
  /** 银联 => 04 */
  UNION_PAY: '04',
  /** 大西洋 => 05 */
  BNU: '05',
  /** 中银VM => 06 */
  BOC_VM: '06',
  /** 银联二维码 */
  // UNION_PAY_QR_CODE: '07'
}

/** 银行支付类型 */
export const BANK_PAY_TYPE = {
  /** 大丰银行-账号 */
  // TAI_FUNG_ACCOUNT: '24',
  /** 大丰银行-借记卡 */
  // TAI_FUNG_DEBIT: '994',
  /** 澳门国际 */
  // LUSO: '34',
  /** 大西洋 => 53 */
  BNU: '53',
  /** 中银VM => 54 */
  BOC_VM: '54',
  /** 银联信用卡 => 48 */
  UNION_PAY: '48',
}

/** 折扣类型 */
export const DISCOUNT_TYPE = {
  /** 隨機立減 */
  RANDOM: '01',
  /** 定額立減 */
  FIXED: '02',
  /** 折扣 */
  DISCOUNT: '03',
  /** 隨機免單 */
  FREE: '04',
}

/** 折扣类型名称 */
export const DISCOUNT_NAME = {
  '01': '隨機立減',
  '02': '定額立減',
  '03': '折扣',
  '04': '隨機免單',
}
